import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import authHeader from "./authHeader";
import { apiInstance } from "./axiosApi";

// GET WITHDRAWAL REQUESTS
export const getWithdrawRequests = createAsyncThunk(
    "withdraw/getWithdrawRequests",
    async ({ page, limit, isWithdrawRequestFilter, search, statusFilter }, { rejectWithValue }) => {
        try {
            let url = `/balance/all?page=${page}&limit=${limit}`;

            if (isWithdrawRequestFilter !== undefined) {
                url += `&isWithdrawRequestFilter=${isWithdrawRequestFilter}`;
            }

            if (search) {
                url += `&search=${search}`;
            }

            if (statusFilter) {
                url += `&statusFilter=${statusFilter}`;
            }

            const response = await apiInstance.get(url, {
                headers: authHeader(),
            });

            return response;
        } catch (error) {
            return rejectWithValue(error?.response?.data || error);
        }
    }
);

// UPDATE WITHDRAW STATUS
export const updateWithdrawStatus = createAsyncThunk(
    "withdraw/updateWithdrawStatus",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await apiInstance.post(`/withdraw/update-status`, payload, {
                headers: authHeader(),
            });

            return response;
        } catch (error) {
            return rejectWithValue(error?.response?.data || error);
        }
    }
);

// Slice (Simple like balanceSlice)
const initialState = {
    withdrawList: null,
};

const withdrawRequestSlice = createSlice({
    name: "withdrawSlice",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getWithdrawRequests.fulfilled, (state, action) => {
            state.withdrawList = action.payload.data;
        });
    },
});

export default withdrawRequestSlice.reducer;
